module.exports = __webpack_public_path__ + "static/media/es-ct.e2e5dbf4.svg";